import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import Hero from '../../components/hero'
import About from '../../components/about'
import Service from '../../components/Service'
import Pilars from '../../components/Pilars'
import EventSection from '../../components/event'
import Support from '../../components/Support'
import BlogSection from '../../components/BlogSection'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import abimg from '../../images/about3.jpg'

import evn1 from '../../images/event/e1.jpg'
import evn2 from '../../images/event/b1.jpg'

import blog1 from '../../images/blog/img-11.jpg'
import blog2 from '../../images/blog/h1.jpg'
import blog3 from '../../images/blog/img-12.jpg'
import hero1 from '../../images/slider/img-3.png'


import v1 from '../../video/v1.mp4'
import v2 from '../../video/v2.mp4'
import v3 from '../../video/v3.mp4'

const HomePage =() => {
    return(
        <Fragment>
            <Navbar/>
            <Hero HeroStyleClass={'hero-style-2'} heroImg={hero1}/>
            
           <div style={{ maxWidth: "100%", margin: "20px auto" ,background: 'linear-gradient(135deg, #d1f1f1, #f0ffff)',padding:"20px"}}>
           

            <div
                style={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                gap: "15px"
                }}
            >
                <video style={{ width: "300px", maxWidth: "100%" ,borderRadius: "15px"}} controls  onLoadedMetadata={(e) => (e.target.currentTime = 6)}> 
                <source src={v1} type="video/mp4" />
                </video>

                <video style={{ width: "300px", maxWidth: "100%" ,borderRadius: "15px"}} controls onLoadedMetadata={(e) => (e.target.currentTime = 4)} >
                <source src={v2} type="video/mp4" />
                </video>

                <video style={{ width: "300px", maxWidth: "100%" ,borderRadius: "15px"}} controls  onLoadedMetadata={(e) => (e.target.currentTime = 6)}>
                <source src={v3} type="video/mp4" />
                </video>
            </div>
            </div>



            
            <About aboutImg={abimg}/>
         {/*    <Service/> */}
            <Pilars/>
            <EventSection eventImg1={evn1} eventImg2={evn2}/>
           {/*  <Support/> */}
            <BlogSection blogImg1={blog1} blogImg2={blog2} blogImg3={blog3}/>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default HomePage;